function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import css from './Close.sass';

var ModalClose = function ModalClose(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return React.createElement("span", _extends({}, props, {
    className: cx(css.root, className)
  }), React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M11.6 9.5L19.2 2c.4-.6.4-1.3 0-1.7-.4-.4-1.2-.4-1.6 0L10 8 2.4.2C2 0 1.2 0 .8.3.4.7.4 1.3.8 2l7.6 7.5-8 8c-.5.5-.5 1.2 0 1.7.2.2.4.3.7.3.4 0 .7 0 1-.3l8-8 8 8c.3.2.6.3 1 .3.2 0 .4 0 .7-.3.4-.5.4-1.2 0-1.6l-8-8z",
    fill: "#D9D9D9",
    fillRule: "evenodd"
  })));
};

ModalClose.propTypes = {
  className: PropTypes.string
};
export { ModalClose };